import { render } from "./ArchivedPeople.vue?vue&type=template&id=5d135a96&scoped=true"
import script from "./ArchivedPeople.vue?vue&type=script&lang=js"
export * from "./ArchivedPeople.vue?vue&type=script&lang=js"

import "./ArchivedPeople.vue?vue&type=style&index=0&id=5d135a96&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d135a96"]])

export default __exports__